import React from 'react';
import { useData } from '../../contexts/DataContext';

const TaskVerification = () => {
  const { tasks, updateTask } = useData();

  const handleStatusChange = async (taskId, newStatus) => {
    await updateTask(taskId, { status: newStatus });
  };

  return (
    <div className="task-verification">
      <div className="page-header">
        <h2>Task Verification</h2>
        <p>Verify and update task completion status</p>
      </div>

      <div className="tasks-list">
        {tasks.map(task => (
          <div key={task.id} className="verification-card">
            <div className="task-info">
              <h3 className='projectNamee'>{task.title}</h3>
              <p>{task.description}</p>
              <div className="task-meta">
                <span>Assigned to: {task.assigneeName}</span>
                <span>Project: {task.projectName}</span>
                <span>Due: {new Date(task.dueDate).toLocaleDateString()}</span>
              </div>
            </div>

            <div className="verification-actions">
              <span className={`current-status status-${task.status}`}>
                Current: {task.status.replace('_', ' ')}
              </span>

              <div className="status-buttons">
                <button 
                  onClick={() => handleStatusChange(task.id, 'not_started')}
                  className={`btn btn-sm ${task.status === 'not_started' ? 'btn-primary' : 'btn-outline'}`}
                >
                  Not Started
                </button>
                <button 
                  onClick={() => handleStatusChange(task.id, 'ongoing')}
                  className={`btn btn-sm ${task.status === 'ongoing' ? 'btn-warning' : 'btn-outline'}`}
                >
                  Ongoing
                </button>
                <button 
                  onClick={() => handleStatusChange(task.id, 'completed')}
                  className={`btn btn-sm ${task.status === 'completed' ? 'btn-success' : 'btn-outline'}`}
                >
                  Completed
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TaskVerification;
